<template>
    <page>
		<module enable-flex>
			<c-table ref="table" :paging="false">
				<c-table-column
					type="expand"
					label="区域"
					name="region_name"
					:expand-limit="3"
					width="300"
					@expand="loadChildren"
				>
				</c-table-column>
				
				<c-table-column label="负责人" width="200">
					<template v-slot="{data}">
						<div class="flex-center-cross">
							<c-image v-if="data.manager_user_id > 0" :src="data.manager_head_photo" preview size="30" style="margin-right: 10px;"></c-image>
							<span v-if="data.manager_user_id > 0">
								{{data.manager_nick_name}}
								<span v-if="data.manager_mobilephone">({{data.manager_mobilephone}})</span>
							</span>
						</div>
					</template>
				</c-table-column>

<!--				<c-table-column label="分红比例" width="120">
					<template v-slot="{data}">
						<span v-if="data.manager_user_id > 0">
							{{data.dividend_ratio}}%
						</span>
					</template>
				</c-table-column>-->

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="110"
				>
					<template v-slot="row">
						<c-table-button power="b_region_set" @click="editHandle(row)">配置负责人</c-table-button>
						<c-table-button power="b_region_set" v-if="row.data.manager_user_id > 0" @click="clearManagerHandle(row)">清除负责人</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	    <c-dialog ref="dialog" title="配置负责人" width="600" height="220" @resolve="setManagerUser">
		    <c-form ref="managerEdit">
			    <c-form-item type="hidden" name="manager_user_id"></c-form-item>
			    <c-form-item type="input" @click="$refs.memberUserSelector.open([3,4])" readonly label="负责人:" name="manager_nick_name" required word="仅允许[城市拓展]或[门店拓展]成为区域负责人"></c-form-item>
<!--			    <c-form-item type="number" decimal="2" :limit="[0,100]" label="分红比例:" name="dividend_ratio" required input-unit="%"></c-form-item>-->
		    </c-form>
	    </c-dialog>
	    <member-user-selector ref="memberUserSelector" @resolve="selectHandle($event)"></member-user-selector>

    </page>
</template>

<script>
	import {mapState} from 'vuex'
	import memberUserSelector from "@/components/service/member_user_selector.vue";
	
	export default {
		name: 'm_region',
		
		components: {
			memberUserSelector
		},
		
		data() {
			return {
				editState: false,
				editLevel: 0,
				productSelectType: [{
					name: '按条件关联',
					value: 1
				}, {
					name: '手动关联',
					value: 2
				}],
				currentProductSelectType: 1,
				sortOptions: [{
					name: '按综合排序',
					value: 'overall desc'
				}, {
					name: '按首次上架时间降序',
					value: 'first_sell_date desc'
				}, {
					name: '按销量降序',
					value: 'product_count desc'
				}],
				productIds: [],
				region_id:0
			}
		},
		
		computed: {
			...mapState(['systemConfig'])
		},
		
		mounted() {
			this.$refs.table.load({
				url: '/platform_user/region/list',
				data: {
					parent_id: 0
				}
			});
		},
		
		methods: {
			loadChildren(row, resolve) {
				this.request({
					url: '/platform_user/region/list',
					data: {
						parent_id: row.data.id
					},
					success: data => {
						resolve(data);
					}
				});
			},

			editHandle(row) {
				this.region_id = row.data.id;
				this._resolve = data => {
					row.update(data);
				};
				var manager_user_id = 0;
				var manager_nick_name = '';
				if (row && row.data && row.data.manager_user_id > 0){
				  manager_user_id = row.data.manager_user_id;
				  manager_nick_name = row.data.manager_nick_name;
				  if (row.data.manager_mobilephone && row.data.manager_mobilephone!=''){
					manager_nick_name = manager_nick_name +'('+row.data.manager_mobilephone+')';
				  }
				}
				this.$refs.managerEdit.clear();
				this.$refs.managerEdit.set({
				  manager_user_id:manager_user_id,
				  manager_nick_name:manager_nick_name
				});
				this.$refs.dialog.open();
			},
            //清除区域负责人
            clearManagerHandle(row) {
                this.$confirm({
                    text: '是否确实清除【'+row.data.region_name+'】地区的负责人？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/platform_user/region/manager/clear',
                            data: {region_id:row.data.id},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '清除成功',
                                    icon: 'success'
                                });
                                row.data.manager_user_id = 0;
                                row.data.manager_nick_name = '';
                                this._resolve = data => {
                                    row.update(data);
                                };
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
			},

			selectHandle(list) {
				var manager_user_id = -1;
				var manager_nick_name = '';
				var manager_mobilephone = '';
				if (list && list[0]){
					manager_user_id = list[0].platform_user_id||-1;
					manager_nick_name = list[0].nick_name;
					manager_mobilephone = list[0].user_manage_mobilephone;
				}
				if (manager_mobilephone && manager_mobilephone!=''){
					manager_nick_name = manager_nick_name +'('+manager_mobilephone+')';
				}
				this.$refs.managerEdit.set({
					manager_nick_name: manager_nick_name,
					manager_user_id: manager_user_id,
				});
			},

			setManagerUser(stop) {
				stop();
				var data = this.$refs.managerEdit.serialize();
				if (!data.manager_user_id) {
					this.$message({
						text: '请选择负责人'
					});
					return;
				}
				data.dividend_ratio = 0;
				data.region_id = this.region_id;
				this.request({
					url: '/platform_user/region/manager/set',
					data: data,
					success: data => {
						this._resolve(data);
						this.$refs.dialog.close();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.group {
		&-img {
			width: 40px;
			height: 40px;
		}
	}
</style>